import React from 'react';
import { Sensor } from '../services/api';

interface SensorHoverTooltipProps {
  hoveredSensor: Sensor;
  hoverPosition: { x: number; y: number };
}

const SensorHoverTooltip: React.FC<SensorHoverTooltipProps> = ({ hoveredSensor, hoverPosition }) => {
  return (
    <div
      className="fixed z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-sm"
      style={{
        left: hoverPosition.x + 10,
        top: hoverPosition.y - 10,
        pointerEvents: 'none',
      }}
    >
      <div className="font-medium">{hoveredSensor.name}</div>
      <div className="text-gray-600">{hoveredSensor.type}</div>
      <div className="text-gray-600">{hoveredSensor.location_name}</div>
      <div className="text-gray-500 text-xs font-mono">
        GPS: {typeof hoveredSensor.coordinates[0] === 'number' ? hoveredSensor.coordinates[0].toFixed(4) : parseFloat(hoveredSensor.coordinates[0] as unknown as string).toFixed(4)}, {typeof hoveredSensor.coordinates[1] === 'number' ? hoveredSensor.coordinates[1].toFixed(4) : parseFloat(hoveredSensor.coordinates[1] as unknown as string).toFixed(4)}
      </div>
      <div className={`text-sm ${
        hoveredSensor.status === 'active' ? 'text-green-600' :
        'text-red-600'
      }`}>
        狀態: {hoveredSensor.status === 'active' ? '正常' :
               '警報'}
      </div>
    </div>
  );
};

export default SensorHoverTooltip;
